import {openGet, OPEN_APP_INFO_HEADERS} from './openAjaxUtils';

export function getOpenMedia(mediaId) {
    return openGet(`/open/article/media/${mediaId}`);
}

export function getOpenNews(id) {
    return openGet(`/open/article/news/${id}`);
}

export function getUserInfoByWecomCode(appId, code) {
    return openGet(`/open/wecom/userinfo`, {
        params: {appId, code},
        headers: OPEN_APP_INFO_HEADERS,
    });
}

export function getWecomCorpId(appId) {
    return openGet(`/open/wecom/corpid`, {
        params: {appId},
        headers: OPEN_APP_INFO_HEADERS,
    });
}

export function getOpenApp(appId) {
    return openGet(`/open/apps/${appId}`, {
        headers: OPEN_APP_INFO_HEADERS,
    });
}

export function getOpenMessage(msgId) {
    return openGet(`/open/messages/${msgId}`, {
        headers: OPEN_APP_INFO_HEADERS,
    });
}

export function getOpenUser(userId) {
    return openGet(`/open/users/${userId}`, {
        headers: OPEN_APP_INFO_HEADERS,
    });
}
